var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.any)?_c('span',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.start)}}),_vm._v(" — "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.end)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }